import apiRequest from '../api-request';

export default async function apiSetDefaultScenario (project, scenario) {
	try {
		const response = await apiRequest('set_default_scenario', {project, scenario});

		return response.data.status === 'SUCCESS' ? response.data.scenariosList : null;
	} catch (e) {
		console.error('There was an error setting the default scenario.', e);

		return false;
	}
}
